import Routings from "./routings";
import CustomRouter from "./CustomRouter";
import {history} from "../helpers/utils"

function App() {
  return (
    <CustomRouter  history={history}>
      <Routings/>
    </CustomRouter>
  )
}

export default App;
